module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/work.json
// module id = 470
// module chunks = 32551418774257